import { useState } from "react";
import { Button, Box, TextField } from "@mui/material";
import NotificationService from "../Notification/notificationService";
import BackdropLoaderService from "../BackdropLoader/backdropLoaderService";
import DialogService from "../Dialog/dialogService";
import { Image } from "../../services/shirts/types";

interface ImagesUploaderFormProps {
  addImage: Function;
  defaultName?: string;
}

/**
 * Component used to select and add a name to the next image
 */
export const ImagesUploaderForm = ({
  defaultName,
  addImage,
}: ImagesUploaderFormProps) => {
  const [image, setImage] = useState<File | undefined>(undefined);

  const maxSizeDefault = 4;
  const filesAllowed = ".jpg, .png, .jpeg";

  const { error } = NotificationService();
  const { close } = DialogService();
  const { open: openBDL, close: closeBDL } = BackdropLoaderService();

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const maxSize = maxSizeDefault * 1048576;
      if (e.target.files[0].size < maxSize) {
        setImage(e.target.files[0]);
      } else {
        error("The max file size allowed is " + maxSizeDefault + "mb");
      }
    }
  };

  const handleSubmit = () => {
    if (image) {
      openBDL();
      let reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = () => {
        var result = reader?.result as string;

        const newImage: Image = {
          data: result.split(",").pop(),
          name: "default",
        };

        addImage(newImage);
        close();
      };
    } else {
      error("File needed.");
    }
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          rowGap: 1,
          columnGap: 1,
          flexWrap: "wrap",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <Box>{image ? image.name : "No image selected"}</Box>
        <Box>
          <Button
            component="label"
            variant="blueGradient"
            sx={{ fontSize: "1rem !important" }}
          >
            Select file
            <input
              accept={filesAllowed}
              value=""
              id="file"
              type="file"
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
          </Button>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginTop: "1rem",
        }}
      >
        <Button onClick={handleSubmit} variant="customBlueText" color="primary">
          Save
        </Button>
      </Box>
    </Box>
  );
};

export default ImagesUploaderForm;
